import React from 'react';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

interface NotificationProps {
    open: string | boolean;
    text: string;
    onClose: Function;
    placement: {
        vertical: string;
        horizontal: string;
    };
    notificationType: 'success' | 'error' | 'warning' | 'info';
}

const Notification = ({text, placement={vertical: 'top', horizontal: 'center' }, open, onClose, notificationType}: NotificationProps) => { 
    return(<Snackbar open={open} anchorOrigin={placement} autoHideDuration={6000} onClose={onClose}>
        <Alert onClose={onClose} severity={notificationType} sx={{ width: '100%' }}>
          {text}
        </Alert>
      </Snackbar>)
}

export default Notification;